export default __webpack_public_path__ + "static/media/bannerBg.62ef0771.png";